import React, { Component } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const images = [
    `${process.env.PUBLIC_URL}/template/img/sebaran-wifi-sampang-1.jpg`,
    `${process.env.PUBLIC_URL}/template/img/sebaran-wifi-sampang-2.jpg`,
    `${process.env.PUBLIC_URL}/template/img/sebaran-wifi-sampang-3.jpg`,
]

const images2 = [
    `${process.env.PUBLIC_URL}/template/img/data-kecelakaan-2.jpg`,
    `${process.env.PUBLIC_URL}/template/img/data-kecelakaan-3.jpg`
]

const images3 = [
    `${process.env.PUBLIC_URL}/template/img/data-persalinan-2.jpg`,
    `${process.env.PUBLIC_URL}/template/img/data-persalinan-3.jpg`
]

const images4 = [
    `${process.env.PUBLIC_URL}/template/img/DataStunting-1.png`,
    `${process.env.PUBLIC_URL}/template/img/DataStunting-2.png`,
    `${process.env.PUBLIC_URL}/template/img/DataStunting-3.png`,
    `${process.env.PUBLIC_URL}/template/img/DataStunting-4.jpeg`,
    `${process.env.PUBLIC_URL}/template/img/DataStunting-5.png`
]

const images5 = [
    `${process.env.PUBLIC_URL}/template/img/drtlh-1.jpg`,
    `${process.env.PUBLIC_URL}/template/img/drtlh-2.jpg`,
    `${process.env.PUBLIC_URL}/template/img/drtlh-3.jpg`,
    `${process.env.PUBLIC_URL}/template/img/drtlh-4.jpg`,
    `${process.env.PUBLIC_URL}/template/img/drtlh-5.jpg`
]

export class InfografikComponentOpenData extends Component {
    render() {
        return (
            <section id="hero" className="d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div
                            className="col-lg-12  text-center pt-5 pt-lg-0"
                            data-aos="fade-up"
                        >
                            <div>
                                <h1>Infografik</h1>
                                <h1 className="font-weight-100">
                                    <br />
                                </h1>
                                <br />
                                <h2>
                                    Merupakan representasi visual informasi, data atau ilmu
                                    pengetahuan secara grafis. Grafik ini memperlihatkan informasi
                                    dengan singkat dan jelas, seperti pada papan, peta,
                                    jurnalisme, penulisan teknis, dan pendidikan. Melalui
                                    infografik, ilmuwan komputer, matematikawan dan statistikawan
                                    mampu mengembangkan dan mengomunikasikan konsep menggunakan
                                    satu simbol untuk memproses informasi.
                                </h2>
                            </div>
                        </div>
                    </div>

                    {/* Sebaran Data Rumah Tidak Layak Huni */}
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={10}
                                slidesPerView={1}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                loop={true}
                            >
                                {images5.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} className="img-fluid" alt={`slide ${index}`} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div
                            className="col-md-8 pt-5 order-2 order-md-1"
                            data-aos="fade-up"
                        >
                            <h2 className="flex-content">
                                <i className="bx bxs-data mr-1"></i>
                                <b>Sebaran Data Rumah Tidak Layak Huni</b>
                            </h2>
                            <p className="font-size-medium font-weight-100">
                                Menampilkan data Rumah Tidak Layak Huni (RTLH) di Kabupaten Sampang, memberikan gambaran jumlah rumah yang teridentifikasi dan yang telah mendapatkan penanganan sejak tahun 2021 hingga 2024. Data ini bertujuan untuk mendukung upaya pemerintah daerah dalam meningkatkan kualitas hunian masyarakat serta mewujudkan lingkungan tempat tinggal yang layak dan sehat bagi warga Sampang
                            </p>
                        </div>
                    </div>

                    {/* Sebaran Data Stunting */}
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-1" data-aos="fade-right">
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={10}
                                slidesPerView={1}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                loop={true}
                            >
                                {images4.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} className="img-fluid" alt={`slide ${index}`} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div
                            className="col-md-8 pt-5 order-2 order-md-1"
                            data-aos="fade-up"
                        >
                            <h2 className="flex-content">
                                <i className="bx bxs-data mr-1"></i>
                                <b>Sebaran Data Stunting</b>
                            </h2>
                            <p className="font-size-medium font-weight-100">
                                Menampilkan sebaran Stunting Balita di Sampang, memberikan
                                gambaran grafik data stunting di berbagai
                                Kecamatan Kabupaten Sampang. Data ini memberikan informasi kepada masyarakat dalam
                                mendukung Prestasi Gemilang Dalam Penurunan Stunting.
                            </p>
                        </div>
                    </div>

                    {/* Sebaran Wifi Sampang */}
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={10}
                                slidesPerView={1}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                loop={true}
                            >
                                {images.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} className="img-fluid" alt={`slide ${index}`} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div
                            className="col-md-8 pt-5 order-2 order-md-1"
                            data-aos="fade-up"
                        >
                            <h2 className="flex-content">
                                <i className="bx bxs-data mr-1"></i>
                                <b>Sebaran Wifi</b>
                            </h2>
                            <p className="font-size-medium font-weight-100">
                                Menampilkan sebaran jaringan WiFi di Sampang, memberikan
                                gambaran lokasi akses internet gratis yang tersedia di berbagai
                                titik strategis, seperti fasilitas umum, dan pusat pemerintah
                                daerah. Data ini bertujuan untuk membantu masyarakat dalam
                                mengakses internet dengan lebih mudah serta mendukung
                                perkembangan digital di daerah tersebut.
                            </p>
                        </div>
                    </div>

                    {/* Sebaran Kecelakan Di Sampang */}
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-1" data-aos="fade-right">
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={10}
                                slidesPerView={1}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                loop={true}
                            >
                                {images2.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} className="img-fluid" alt={`slide ${index}`} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div
                            className="col-md-8 pt-5 order-2 order-md-1"
                            data-aos="fade-up"
                        >
                            <h2 className="flex-content">
                                <i className="bx bxs-data mr-1"></i>
                                <b>Sebaran Kecelakan</b>
                            </h2>
                            <p className="font-size-medium font-weight-100">
                                Sebaran kecelakaan di Sampang guna mendukung analisis dan perumusan kebijakan keselamatan yang lebih efektif. Data ini memberikan gambaran jelas tentang tren, lokasi, dan faktor penyebab kecelakaan untuk meningkatkan upaya pencegahan dan respons cepat.
                            </p>
                        </div>
                    </div>

                    {/* Sebaran Jumlah Persalinan Di Faskes Sampang */}
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                            <Swiper
                                modules={[Autoplay]}
                                spaceBetween={10}
                                slidesPerView={1}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                loop={true}
                            >
                                {images3.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} className="img-fluid" alt={`slide ${index}`} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div
                            className="col-md-8 pt-5 order-2 order-md-1"
                            data-aos="fade-up"
                        >
                            <h2 className="flex-content">
                                <i className="bx bxs-data mr-1"></i>
                                <b>Sebaran Jumlah Persalinan Faskes</b>
                            </h2>
                            <p className="font-size-medium font-weight-100">
                                Sebaran jumlah persalinan di fasilitas kesehatan (Faskes) Kabupaten Sampang dengan data terpadu untuk mendukung perencanaan kebijakan kesehatan yang lebih akurat dan berbasis fakta. Data ini bertujuan untuk memudahkan pemahaman tren dan distribusi layanan persalinan di berbagai Faskes.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default InfografikComponentOpenData;
